// extracted by mini-css-extract-plugin
export const arrowLink = "arrow-link-module--arrowLink--35Y9f";
export const arrow = "arrow-link-module--arrow--11nYs";
export const arrowContainer = "arrow-link-module--arrowContainer--LBmrK";
export const arrowLinkRow = "arrow-link-module--arrowLinkRow--1xx1Z";